import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-pending-cert-delete',
    templateUrl: './dialog-pending-cert-delete.component.html',
    styles: [],
    standalone: false
})
export class DialogPendingCertDeleteComponent implements OnInit {
  public isMobile: boolean;
  public constructor(
    public dialogRef: MatDialogRef<DialogPendingCertDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.isMobile = environment.platform === 'mobile';
  }

  public ngOnInit() {}
}
